export default __webpack_public_path__ + "static/media/close-modal.521934a3.svg";